import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FetchUserAttributesOutput } from "aws-amplify/auth";
import { reducerType } from ".";

const initialState = {} as FetchUserAttributesOutput;

const UserProfileSlice = createSlice({
  name: "UserProfile",
  initialState,
  reducers: {
    setUserProfile(
      state: FetchUserAttributesOutput,
      action: PayloadAction<FetchUserAttributesOutput>,
    ) {
      const { payload } = action;
      return { ...state, ...payload };
    },
  },
});

export const selectSellerAlias = (state: reducerType) =>
  state.UserProfile.userId;
export const { setUserProfile } = UserProfileSlice.actions;
export default UserProfileSlice.reducer;
